import { NgModule, APP_INITIALIZER} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; 
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonsModule } from './commons.module'
import { AppComponent } from './app.component';
import { TransactionRunnerComponent } from './transaction-runner.component';
import { TermComponent } from './term.component';

import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { ConfigService } from './config-service';
import { AppConfigurationMessage } from './configuration-message.module';

// Provided to dynamically loaded components
import { SharedModule } from './shared.module';
import { TermModule } from './term/term.module';
import { DynamicFieldModule } from './dynamic-field/dynamic-field.module';
import { TermModalModule } from './term-modal/term-modal.module';
import { TermService } from './term/term.service';
import { TestingService } from './term/testing.service';
import { TransactionService } from './term/transaction.service';
import { TableModule } from './table/table.module';
import { ModalModule, ModalComponent } from './modal.component';

import { S142gComponents, S142gModule } from './maps/s142g';
import { S101gComponents, S101gModule } from './maps/s101g';
import { S143gComponents, S143gModule } from './maps/s143g';
import { S129gComponents, S129gModule } from './maps/s129g';
import { S121gComponents, S121gModule } from './maps/s121g';
import { MapsetComponents, MapsetModule } from './maps/mapset';
import { S102gComponents, S102gModule } from './maps/s102g';
import { S145gComponents, S145gModule } from './maps/s145g';
import { S126gComponents, S126gModule } from './maps/s126g';
import { S127gComponents, S127gModule } from './maps/s127g';
import { S141gComponents, S141gModule } from './maps/s141g';
import { S123gComponents, S123gModule } from './maps/s123g';
import { S128gComponents, S128gModule } from './maps/s128g';
import { S146gComponents, S146gModule } from './maps/s146g';
import { S1dbgComponents, S1dbgModule } from './maps/s1dbg';
import { S125gComponents, S125gModule } from './maps/s125g';
import { S124gComponents, S124gModule } from './maps/s124g';
import { S140gComponents, S140gModule } from './maps/s140g';
import { S110gComponents, S110gModule } from './maps/s110g';
import { S144gComponents, S144gModule } from './maps/s144g';
import { S122gComponents, S122gModule } from './maps/s122g';
import { UtilityComponents, UtilityModule } from './maps/utility';
import { UserInfoService } from './user-info/user-info.service';
import { UserInfoComponent } from './user-info.component';

import { FormsModule } from '@angular/forms';
import { S999gModule } from './maps/s999g/s999g.module';

/** Perform application configuration.
 * The application start will delay until the Promise is completed (avoid race conditions).
 * See https://github.com/angular/angular/issues/9047
  */
export function initializeApplication(http: HttpClient, 
    transactionService: TransactionService, userInfoService: UserInfoService, configService: ConfigService) {
    
    // Get backend URL
    return () => configService.configuration()
        .then((configuration: AppConfigurationMessage) => {
            transactionService.configure(configuration);
            userInfoService.configure(configuration);
            return true;
        });
}

@NgModule({
    imports: [
        CommonsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        MatProgressSpinnerModule,
        SharedModule,
        DynamicFieldModule,
        TableModule,
        TermModule,
        TermModalModule,
        ModalModule,
        S142gModule,
        S101gModule,
        S143gModule,
        S129gModule,
        S121gModule,
        MapsetModule,
        S102gModule,
        S145gModule,
        S126gModule,
        S127gModule,
        S141gModule,
        S123gModule,
        S128gModule,
        S146gModule,
        S1dbgModule,
        S125gModule,
        S124gModule,
        S140gModule,
        S110gModule,
        S144gModule,
        S999gModule,
        S122gModule,
        UtilityModule
    ],
    declarations: [
        AppComponent,
        TermComponent,
        TransactionRunnerComponent,
        UserInfoComponent,
    ],
    bootstrap: [
        AppComponent,
    ],
    providers: [
        AppService,
        TermService,
        TransactionService,
        UserInfoService,
        ConfigService,
        TestingService,
        {
            'provide': APP_INITIALIZER,
            'useFactory': initializeApplication,
            'deps': [HttpClient, TransactionService, UserInfoService, ConfigService],
            'multi': true,
        }
    ]
})
export class AppModule { }
